/**
 * Validates email
 *
 * @param {string} email Email.
 * @returns {boolean} Regex result
 */
export const emailValidator = (email) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegex.test(String(email).toLowerCase());
};

/**
 * Validates user password
 *
 * @param {string} password User password.
 * @param {string} password_confirmation Password confitmation.
 *
 * @returns {object} Object with validation results.
 */
export const passwordValidator = (password, password_confirmation) => {
    if (! password) {
        return {
            validation: false,
            message: 'Password cannot be empty',
        };
    }

    if (8 > password.length) {
        return {
            validation: false,
            message: 'Password must be at least 8 characters long',
        };
    }

    if (password_confirmation || '' === password_confirmation) {
        if (password !== password_confirmation) {
            return {
                type: 'all',
                validation: false,
                message: 'The passwords do not match',
            };
        }
    }

    return {
        validation: true,
    };
};

/**
 * Validates if user name is not empty
 *
 * @param {string} name Data.
 * @returns {boolean} Validation result.
 */
export const userNameValidator = (name) => {
    if (! name || 0 === name.length) {
        return {
            validation: false,
            message: 'The name field is required.',
        };
    }

    return {
        validation: true,
    };
};
